export enum ExternalCalendarWorkflowType {
  DELIVERY = 'Delivery',
  FORM = 'Form',
}
